<template src="./Map.html"></template>

<script>

import L from "leaflet";
import "leaflet.vectorgrid";

import "leaflet/dist/leaflet.css";

import { mapActions, mapState } from 'vuex';

import MenuIcon from '@/components/Menu/MenuIcon/MenuIcon.vue';
import MenuTitle from '@/components/Menu/MenuTitle/MenuTitle.vue';
import MenuOption from '@/components/Menu/MenuOption/MenuOption.vue';
import MenuSelect from '@/components/Menu/MenuSelect/MenuSelect.vue';
import MenuList from '@/components/Menu/MenuList/MenuList.vue';
import MenuButton from '@/components/Menu/MenuButton/MenuButton.vue';

import MapLegend from '@/components/Map/MapLegend/MapLegend.vue';

export default {
  name: "MapLayer",
  components: {
    MenuIcon,
    MenuTitle,
    MenuOption,
    MenuSelect,
    MenuList,
    MenuButton,
    MapLegend,
  },
  props: {
    mapMode: {
      type: Object,
      required: false
    }
  },
  data: () => ({
    visible: false,
    mapMarker: null,
    mapMarkerTwo: null,

    vwsMapMarker: null,

    mapCurrent: "",
    switchMap: false,

    map1Layer: null,

    mapLayers: [],

    mapOpacity: 0.9, // default opacity for map layers

    // Debounced updater reference
    updateWsLayersThrottled: null,
    updateMap1Throttled: null,
    updateMap2Throttled: null,

    // Debounce map full screen toggle to prevent rapid invalidateSize calls
    dataAnalysisFullScreenDebounce: null,
  }),

  methods: {
    // Simple debounce helper to avoid rapid redraws
    debounce(fn, wait = 120) {
      let t = null;
      return (...args) => {
        if (t) clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
      };
    },

    ...mapActions({
      setLatLon: 'setLatLon',
      getGeoInfo: 'getGeoInfo',
      setDataAnalysisStatus: 'setDataAnalysisStatus',
      setDataAnalysisFullScreen: "setDataAnalysisFullScreen",

      setAlert: 'setAlert',

      setWsLayerStatus: 'setWsLayerStatus',
      setVirtualStationLatLon: 'setVirtualStationLatLon',

      setViewNotificationsManager: 'setViewNotificationsManager',

      setMenuSettings: 'setMenuSettings',
      setMapOne: 'setMapConfigOne',

      setDropPinStatus: "setDropPinStatus",
    }),

    mapVisibilityChange(e) {
      this.visible = !this.visible;
      e.stopPropagation();
    },

    loadMapLayer: function() {

      // if (this.variables.itemSelected == '') {
      //     this.setAlert({message: 'Please select a Variable!', type: 'error'});
      //     return;
      // }
      this.setMenuSettings({
          geoid: 'us', 
          variable: this.variables.itemSelected,
          period: { 
              period: this.timePeriods.itemSelected
          }
      });

      let toSetLayerOne = this.variables.itemSelected.id;
      if (this.mapConfigOne.layer != '') {
          let tp = this.mapConfigOne.layer.substring(this.mapConfigOne.layer.length - 3, this.mapConfigOne.layer.length)
          if (tp == 'Dev' || tp == 'His')
              toSetLayerOne += tp;
      }
      // console.log('a lauyer que3 vai chamar: ', this.variables.itemSelected.layer)
      let map1 = {
          url: this.variables.itemSelected.id == 'thi'  ? '' : 'https://wms.agroclimate.org/wms?geoid=' + this.regionOfInterest.itemSelected + '&band=' + this.variables.itemSelected.layer + '&period=' + this.timePeriods.itemSelected + "&date=20210713",
          layer: toSetLayerOne,
          visibility: this.mapConfigOne.visibility
      };

      this.setMapOne(map1);

    },

    onMapClick: function (e) {

      // Show New Virtual Weather station on the map
      if (this.newVirtualStation.status) {
        if (this.vwsMapMarker == null) {
          this.vwsMapMarker = new L.marker(e.latlng, { draggable: "false" });
          this.map.addLayer(this.vwsMapMarker);
        } else
          this.vwsMapMarker.setLatLng(e.latlng);

        this.setVirtualStationLatLon({
          name: this.newVirtualStation.name,
          status: this.newVirtualStation.status,
          latitude: e.latlng.lat,
          longitude: e.latlng.lng,
        });
        
      } else {
        if (this.vwsMapMarker != null)
          this.map.removeLayer(this.vwsMapMarker);
        this.vwsMapMarker = null;
      }

      if (!this.isShowDropPin) {
        this.mapMarker = null;
        this.mapMarkerTwo = null;
        return;
      }

      if (this.mapMarker == null) {
        this.setDataAnalysisFullScreen(true);

        this.mapMarker = new L.marker(e.latlng, { draggable: "true" });
        this.mapMarkerTwo = new L.marker(e.latlng, { draggable: "true" });

        // 
        this.mapMarker.on("dragend", (event) => {
          var marker = event.target;
          var position = marker.getLatLng();
          marker.setLatLng(new L.LatLng(position.lat, position.lng), {
            draggable: "true",
          });
          //
          this.mapMarkerTwo.setLatLng({lat: position.lat, lng: position.lng});
          this.setLatLon({latitude: position.lat, longitude: position.lng});
        });

        this.mapMarkerTwo.on("dragend", (event) => {
          var marker = event.target;
          var position = marker.getLatLng();
          marker.setLatLng(new L.LatLng(position.lat, position.lng), {
            draggable: "true",
          });
          this.mapMarker.setLatLng({lat: position.lat, lng: position.lng});
          this.setLatLon({latitude: position.lat, longitude: position.lng});
        });

        this.map.addLayer(this.mapMarker);
        this.mapTwo.addLayer(this.mapMarkerTwo);
        this.setDataAnalysisStatus(true);

        this.savePinLocalStorage(); // Save the pin to local storage

      } else {
        this.mapMarker.setLatLng(e.latlng);
        this.mapMarkerTwo.setLatLng(e.latlng);
        this.savePinLocalStorage(); // Save the pin to local storage
      }
      //
      
      this.setLatLon({ latitude: e.latlng.lat, longitude: e.latlng.lng });
      //this.getGeoInfo({latitude: e.latlng.lat, longitude: e.latlng.lng});
    },


    savePinLocalStorage: function () {
      if (this.mapMarker == null) {
        return;
      }

      const latLng = this.mapMarker.getLatLng();

      // Delete the previous saved pin if exists
      localStorage.removeItem('lastPin');

      localStorage.setItem('lastPin', JSON.stringify({
        latitude: latLng.lat,
        longitude: latLng.lng
      }));

    },


    setupLeafletMap: function () {
      this.map = L.map("mapContainer", {}).setView([37.7749, -101.4194], 4);
      this.mapTwo = L.map("mapContainer-two", {}).setView([37.7749, -101.4194], 4);

      L.DomEvent.disableScrollPropagation(document.getElementById('selectorMenu1'));

      // Prevent the map height overflows the div limit
      this.map.getContainer().focus = ()=>{}
      this.mapTwo.getContainer().focus = ()=>{}
      
      L.tileLayer(
        'https://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}',
        { maxZoom: 18, id: "mapbox/streets-v11", subdomains:['mt0','mt1','mt2','mt3'] },        
      ).addTo(this.map);
      this.map.on('click', this.onMapClick);

      L.tileLayer(
        //"https://api.mapbox.com/styles/v1/{id}/tiles/{z}/{x}/{y}?access_token=pk.eyJ1Ijoic3dldGFyYXRob3JlIiwiYSI6ImNranlsd2dwZTAwMHUyb3ByNHUyaHV2emMifQ.hw4neBSTRPSjXwk0rqqkaQ",
        'https://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}',
        { maxZoom: 18, id: "mapbox/streets-v11", subdomains:['mt0','mt1','mt2','mt3'] },
      ).addTo(this.mapTwo);
      this.mapTwo.on('click', this.onMapClick);

    },


    mapLayersMapOne() {

      if (this.map == undefined) return;

      this.map.eachLayer(layer => {
          // Keep base tile
          if (layer._url == 'https://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}') return;

          // Keep markers (e.g., virtual weather stations, pins)
          if (typeof L !== 'undefined' && layer instanceof L.Marker) return;

          // Remove other layers (WMS, vector tiles, image overlays)
          this.map.removeLayer(layer);
      });

      L.tileLayer.wms(this.mapMode.map1.url, { layers: this.mapMode.map1.layer }).addTo(this.map);

      let vectorTileOptions = {
        rendererFactory: L.canvas.tile,
        minZoom: 5,
        maxZoom: 18,
        interactive: true,
        vectorTileLayerStyles: {
          sliced: {
            weight: 2,
                fillColor: 'red',
                color: 'red',
            },
              color: 'red'
          },
          color: 'red',
      };

      if (this.wfsLayers.length > 0) {
        if (this.wfsLayers[0].status) {
          let wfsUrl = 'https://api.agroclimate.org/v2/map/shapefile/tiles/{z}/{x}/{y}?geoid=US__';
          if (this.wfsLayers[0].boundaries == 'county')
            wfsUrl = 'https://api.agroclimate.org/v2/map/shapefile/tiles/{z}/{x}/{y}?geoid=US%';
          let x = L.vectorGrid.protobuf(wfsUrl, vectorTileOptions).addTo(this.map);
          x.on('click', (e) => console.log(e.target));
          
        }
      }

       // Hack to fit map to div size (when two maps are visibile)
      setTimeout(() =>  {
        this.mapTwo.invalidateSize();
        this.map.invalidateSize();
        if (this.mapMarker != null)
          this.map.addLayer(this.mapMarker)

        this.onOpacityChange();
      }, 500);

    },

    mapLayersMapTwo() {
      
      if (this.mapTwo == undefined) return;

      this.mapTwo.eachLayer(layer => {
      // Keep base tile
      if (layer._url == 'https://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}') return;

      // Keep markers (e.g., virtual weather stations, pins)
      if (typeof L !== 'undefined' && layer instanceof L.Marker) return;

      // Remove other layers (WMS, vector tiles, image overlays)
      this.mapTwo.removeLayer(layer);
      });

      L.tileLayer.wms(this.mapMode.map2.url, { layers: this.mapMode.map2.layer }).addTo(this.mapTwo);

      // Hack to fit map to div
      setTimeout(() =>  {
        this.mapTwo.invalidateSize();
        this.map.invalidateSize();
        if (this.mapMarkerTwo != null)
          this.mapTwo.addLayer(this.mapMarkerTwo)

        this.onOpacityChange();
      }, 500);
    },

    removeMapMarkers() {
      this.mapMarker = this.mapMarkerTwo = null;
    },

    centerMapOnDataAnalysis() { 
      setTimeout(() => {
        this.mapTwo.invalidateSize();
        this.map.invalidateSize();
        if (this.mapMarker != null) {
          this.map.setView(this.mapMarker.getLatLng(), 5);
          this.mapTwo.setView(this.mapMarker.getLatLng(), 5);
        }
      }, 500);
    },


    // Show / Hide Virtual Weather Stations
    setMapLayers() {
      // Ensure map exists
      if (!this.map) return;

      // Remove existing station markers
      if (this.mapLayers && this.mapLayers.length > 0) {
        this.mapLayers.forEach(m => {
          try {
            this.map.removeLayer(m);
          } catch (err) {
            // ignore
          }
        });
        this.mapLayers = [];
      }

      // If WS layer visibility toggle indicates markers should be shown
      if (!this.viewWsLayer) {
        // Exclude virtual weather stations from the map markers
        this.ws.filter(w => !w.pvt).forEach(w => {
          const matches = w.name ? w.name.match(/\b(\w)/g) : null;
          const acronym = matches ? matches.join('') : '';

          const markerIcon = L.icon({
            iconUrl: 'https://api.geoapify.com/v1/icon?type=circle&color=%23ed8124&text=' + encodeURIComponent(acronym) + '&scaleFactor=2&apiKey=ddb32e30c569497c8a0004751a1a23f4',
            iconSize: [32, 32],
          });

          const marker = L.marker([w.loc.lat, w.loc.lon], { icon: markerIcon });
          marker.addTo(this.map).bindPopup(w.name);
          marker.on('click', (e) => {
            this.setLatLon({ latitude: e.latlng.lat, longitude: e.latlng.lng });
            this.setDataAnalysisStatus(true);
            this.setViewNotificationsManager(false);
          });
          this.mapLayers.push(marker);
        });
      }

    },

    // Close the map marker if the user is creating a virtual weather station but have saved or canceled
    setVwsMapMarkerStatus() {
      this.map.removeLayer(this.vwsMapMarker);
      this.vwsMapMarker = null;
    },

    onClimateIndicatorChange() {

      this.setMenuSettings({
          geoid: 'us', 
          variable: this.variables.itemSelected,
          period: { 
              period: this.timePeriods.itemSelected
          }
      });

      let toSetLayerOne = this.variables.itemSelected.id + this.mapLayerType;
      // if (this.mapConfigOne.layer != '') {
      //     let tp = this.mapConfigOne.layer.substring(this.mapConfigOne.layer.length - 3, this.mapConfigOne.layer.length)
      //     if (tp == 'Dev' || tp == 'His')
      //         toSetLayerOne += tp;
      // }

      let map1 = {
          url: this.variables.itemSelected.id == 'thi'  ? '' : 'https://wms.agroclimate.org/wms?geoid=' + 'us' + '&band=' + this.variables.itemSelected.layer + '&period=' + this.timePeriods.itemSelected + "&date=20210713",
          layer: toSetLayerOne,
          visibility: this.mapConfigOne.visibility,
          opacity: this.mapOpacity // Use the current opacity value
      };

      // this.onOpacityChange(this.mapOpacity); // Ensure opacity is updated before setting the map
      setTimeout(() => {
        this.onOpacityChange(this.mapOpacity); // Ensure opacity is updated before setting the map
      }, 500);

      this.setMapOne(map1);

    },

    onOpacityChange(_opacity=null) {
      // If _opacity is provided, use it; otherwise, use the current mapOpacity
      var newOpacity = _opacity !== null ? _opacity : this.mapOpacity;

      // Helper: Only apply to raster layers (TileLayer/WMS/ImageOverlay), not markers or vector overlays
      const applyOpacity = (map) => {
        if (!map) return;
        map.eachLayer(layer => {
          // Skip Google base tiles by url match
          if (layer && layer._url === 'https://{s}.google.com/vt/lyrs=s,h&x={x}&y={y}&z={z}') return;

          const isTile = (typeof L !== 'undefined') && (layer instanceof L.TileLayer);
          const isImage = (typeof L !== 'undefined') && (layer instanceof L.ImageOverlay);

          if ((isTile || isImage) && typeof layer.setOpacity === 'function') {
            layer.setOpacity(newOpacity);
          }
        });
      };

      if (this.mapConfigOne) applyOpacity(this.map);
      if (this.mapConfigTwo) applyOpacity(this.mapTwo);
    },

    dataAnalysisAnimation() {
      if (this.dataAnalysisFullScreenDebounce) {
        clearInterval(this.dataAnalysisFullScreenDebounce);
        this.dataAnalysisFullScreenDebounce = null;
      }

      this.$nextTick(() => {
        this.dataAnalysisFullScreenDebounce = setInterval(() => {
          if (this.map) this.map.invalidateSize();
          if (this.mapTwo) this.mapTwo.invalidateSize();
        }, 10);

        setTimeout(() => {
          if (this.dataAnalysisFullScreenDebounce) {
            clearInterval(this.dataAnalysisFullScreenDebounce);
            this.dataAnalysisFullScreenDebounce = null;
          }
        }, 400);
      });
    }

  },

  computed: {

    ...mapState({

      mapLatLon: state => state.mapLatLon,
      isShowDataAnalysis: state => state.dataAnalysisStatus,
      isShowPin: state => state.dropPinStatus,

      mapConfigOne: state => state.mapConfigOne,
      mapConfigTwo: state => state.mapConfigTwo,

      menuConfig: state => state.menuSettings,

      //layers: state => state.map.mapLayers,

      newVirtualStation: state => state.map.newVirtualStationLatLon,

      viewWsLayer: state => state.ws.viewWsLayer,
      ws: state => state.ws.ws,

      wfsLayers: state => state.map.wfsLayers,
      mapLayerType: state => state.map.mapType,

      dataAnalysisFullScreen: state => state.dataAnalysisFullScreen,
      dataAnalysisStatus: (state) => state.dataAnalysisStatus,

      variables: state => state.variables.monitoring.variables,
      timePeriods: state => state.variables.monitoring.timePeriods,
    }),

    newVirtualStationStatus() {
      if (!this.newVirtualStation.status && this.vwsMapMarker)
        this.setVwsMapMarkerStatus(this.newVirtualStation.status);
      return this.newVirtualStation.status;
    },

    getMapLayers() {
      return this.ws;
    },

    getMenuStatus() {
      return this.mapMode;
    },

    isShowDropPin: function() {
      if (!this.isShowPin) {
        if (this.mapMarker != null) {
          this.map.removeLayer(this.mapMarker);
          this.mapTwo.removeLayer(this.mapMarkerTwo);
          this.map.invalidateSize();
          this.mapTwo.invalidateSize();
          this.removeMapMarkers();
        }
      } else {
        if (this.mapMarker == null)
          this.setAlert({message: 'Click on the map to get started!', type: 'info'});
      }
      if (this.isShowPin) {
        this.centerMapOnDataAnalysis();
      }
      return this.isShowPin;
    },

  },

  mounted() {
    this.setupLeafletMap();

    let map1 = {
      url: 'https://wms.agroclimate.org/wms?geoid=' + 'us' + '&band=' + this.variables.itemSelected.layer + '&period=' + this.timePeriods.itemSelected + "&date=20210713",
      layer: this.variables.itemSelected.id + this.mapLayerType,
      visibility: true,
      opacity: this.mapOpacity // Use the current opacity value
    };

    setTimeout(() => {
      this.onOpacityChange(); // Ensure opacity is updated before setting the map
    }, 500);

    this.setMapOne(map1);

    this.setMenuSettings({
      geoid: 'us', 
      variable: { id: 'totR', unit: 'in', layer: 1, threshold: '1', title: 'Total Precipitation' },
      period: { 
        period: 30
      }
    });

    let lastPin = localStorage.getItem('lastPin');
    if (lastPin) {
      lastPin = JSON.parse(lastPin);
      if (lastPin.latitude && lastPin.longitude) {
        let latlng = {
          latlng: new L.LatLng(lastPin.latitude, lastPin.longitude),
        };

        this.setDropPinStatus(true); // Enable drop pin mode
        this.onMapClick(latlng);
      }
    }
    
    // Initialize debounced updater and run once
    if (!this.updateWsLayersThrottled) {
      this.updateWsLayersThrottled = this.debounce(this.setMapLayers, 120);
    }
    this.updateWsLayersThrottled();

    // Debounced raster updaters
    if (!this.updateMap1Throttled) this.updateMap1Throttled = this.debounce(this.mapLayersMapOne, 120);
    if (!this.updateMap2Throttled) this.updateMap2Throttled = this.debounce(this.mapLayersMapTwo, 120);
  },

  watch: {
    // Redraw markers only when station list changes (array ref) or visibility toggle changes
    ws() {
      if (this.updateWsLayersThrottled) this.updateWsLayersThrottled();
    },
    // If the WS layer visibility toggles, update markers only
    viewWsLayer() {
      if (this.updateWsLayersThrottled) this.updateWsLayersThrottled();
    },

    // Update rasters only when map configurations change
    mapConfigOne: {
      deep: true,
      handler() {
        if (this.updateMap1Throttled) this.updateMap1Throttled();
      }
    },
    mapConfigTwo: {
      deep: true,
      handler() {
        if (this.updateMap2Throttled) this.updateMap2Throttled();
      }
    },
    mapLatLon: function(newValue, oldValue) {
      if (oldValue.latitude == newValue.latitude && oldValue.longitude == newValue.longitude) return;

      console.log(`Updating from ${newValue.latitude}, ${newValue.longitude} to ${oldValue.latitude}, ${oldValue.longitude}`);

      let latlng = {
        latlng: new L.LatLng(newValue.latitude, newValue.longitude),
      };

      // console.log("Setting a new marker location", latlng);

      this.setDropPinStatus(true);
      this.onMapClick(latlng);

      // console.log("-------------------------------------------------------------------------------------------------------------------")
    },
    dataAnalysisFullScreen() {
      this.dataAnalysisAnimation();
    },
    dataAnalysisStatus() {
      this.dataAnalysisAnimation();
    },
  }
  
};
</script>

<style lang="scss" src="./Map.scss">
</style>